module.exports = __webpack_public_path__ + "img/t3-c9.0dc6274b.png";